import { color, section, button, align } from '@settings/common';

export function Schema({ article, blog, collection }) {
  if (article || blog || collection) return null;

  return {
    label: 'Three Tile',
    key: 'three-tile',
    fields: [
      {
        name: 'tiles',
        label: 'Tiles',
        description: 'Max of 3 tiles',
        component: 'group-list',
        itemProps: {
          label: '{{item.heading}}',
        },
        defaultItem: {
          heading: 'New Tile',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.',
          alt: 'Tile image',
          image: {
            src: 'https://images.unsplash.com/photo-1528629297340-d1d466945dc5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80',
          },
          cta: {
            text: '',
            url: '',
          },
        },
        validate: {
          maxItems: 3,
        },
        fields: [
          {
            name: 'heading',
            label: 'Heading',
            component: 'text',
          },
          {
            name: 'description',
            label: 'Description',
            component: 'markdown',
          },
          {
            label: 'Link',
            name: 'cta',
            component: 'link',
          },
          {
            label: 'Image Alt',
            name: 'alt',
            component: 'text',
            description:
              'Provide a brief description of the image for accessibility compliance',
          },
          {
            label: 'Image',
            name: 'image',
            component: 'image',
          },
        ],
        defaultValue: [
          {
            heading: 'New Releases',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.',
            cta: {
              text: 'Shop Now',
              url: '/collections/all',
            },
            alt: 'Tile image',
            image: {
              src: 'https://images.unsplash.com/photo-1528629297340-d1d466945dc5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80',
            },
          },
          {
            heading: 'Top Products',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.',
            alt: 'Tile image',
            image: {
              src: 'https://images.unsplash.com/photo-1571333250176-3c316199994b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80',
            },
            cta: {
              text: 'Shop Now',
              url: '/collections/all',
            },
          },
          {
            heading: 'Bundles',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.',
            alt: 'Tile image',
            image: {
              src: 'https://images.unsplash.com/photo-1523357585206-175e971f2ad9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80',
            },
            cta: {
              text: 'Shop Now',
              url: '/collections/all',
            },
          },
        ],
      },
      {
        label: 'Heading Settings',
        name: 'header',
        description: 'Heading, text align, heading button',
        component: 'group',
        fields: [
          {
            name: 'heading',
            component: 'text',
            label: 'Heading',
          },
          {
            component: 'radio-group',
            direction: 'horizontal',
            description: "Doesn't apply on desktop if button is in header",
            variant: 'radio',
            name: 'textAlign',
            label: 'Heading alignment',
            options: align.options,
          },
          {
            name: 'ctas',
            label: 'Heading Button',
            component: 'group-list',
            description: 'Max of 1 button',
            itemProps: {
              label: '{{item.cta.text}}',
            },
            validate: {
              maxItems: 1,
            },
            defaultItem: {
              cta: {
                text: "Shop What's Trending",
                url: '/collections/all',
              },
              style: button.value.secondary,
            },
            fields: [
              {
                name: 'cta',
                component: 'link',
                label: 'Button',
              },
              {
                name: 'style',
                label: 'Button style',
                component: 'select',
                options: button.options,
              },
            ],
          },
        ],
        defaultValue: {
          heading: 'Trending Now',
          textAlign: align.value.center,
          ctas: [
            {
              cta: {
                text: "Shop What's Trending",
                url: '/collections/all',
              },
              style: button.value.secondary,
            },
          ],
        },
      },
      {
        label: 'Tile Settings',
        name: 'tile',
        description: 'Display, image ratio, text align, link style',
        component: 'group',
        fields: [
          {
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            name: 'display',
            label: 'Tile display (mobile)',
            options: [
              { label: 'Slider', value: 'slider' },
              { label: 'Stacked', value: 'stacked' },
            ],
          },
          {
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            name: 'imageRatio',
            label: 'Image aspect ratio',
            options: [
              { label: '1:1', value: 'square' },
              { label: '3:4', value: 'portrait' },
            ],
          },
          {
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            name: 'textAlign',
            label: 'Text alignment',
            options: align.options,
          },
          {
            name: 'ctaStyle',
            label: 'Link style',
            component: 'select',
            options: button.options,
          },
        ],
        defaultValue: {
          display: 'slider',
          imageRatio: 'portrait',
          textAlign: align.value.left,
          ctaStyle: button.value.secondary,
        },
      },
      {
        ...section,
        defaultValue: {
          bgColor: color.value.background,
          color: color.value.text,
          mobile: {
            container: 'container',
            mt: 'none',
            py: 'm',
          },
          desktop: {
            container: 'content',
            mt: 'none',
            py: 'm',
          },
        },
      },
    ],
  };
}
